import { gql } from '@apollo/client';

export const SUCCESS_QUERY = gql`
  query CheckoutSuccessQuery {
    user {
      id
      language
      hash
    }

    magento2 {
      customer {
        nativeId
        firstname
        email
      }
      cmsBlocks(
        identifiers: [
          "success-hardware-notice"
          "success-general-notice"
          "success-software-notice"
        ]
      ) {
        items {
          title
          identifier
          content
        }
      }
    }
  }
`;

export const ORDER_QUERY = gql`
  query CheckoutOrderQuery($orderNumber: String) {
    magento2 {
      storeConfig {
        storeCode
        taxSalesDisplayPrice
        taxSalesDisplaySubtotal
      }
      customer {
        nativeId
        globalOrders(filter: { number: { eq: $orderNumber } }, pageSize: 1) {
          items {
            number
            id
            isVirtual
            carrier
            storeCode
            shippingMethod
            billingAddress {
              city
              region
              countryCode
            }
            paymentMethods {
              name
            }
            items {
              productName
              productSku
              quantityOrdered
              productImage
              id
              productSalePrice {
                currency
                value
              }
              productSalePriceIncludingTax {
                currency
                value
              }
              productType
              discounts {
                amount {
                  currency
                  value
                }
                label
              }
            }
            total {
              discounts {
                label
                amount {
                  currency
                  value
                }
              }
              totalShipping {
                value
                currency
              }
              shippingHandling {
                amountExcludingTax {
                  value
                  currency
                }
                amountIncludingTax {
                  value
                  currency
                }
              }
              grandTotal {
                currency
                value
              }
              taxes {
                title
                amount {
                  currency
                  value
                }
              }
              totalTax {
                currency
                value
              }
              subtotal {
                currency
                value
              }
              subtotalIncludingTax {
                currency
                value
              }
            }
          }
        }
      }
    }
  }
`;
